import PricesScrollableList from 'components/Lists/ListView/PricesScrollableList';
import RestaurantsScrollableList from 'components/Lists/ListView/RestaurantsScrollableList';
import Text from 'components/Text/Text';
import React from 'react';
import { IItemModifier } from 'types';
import classNames from 'classnames';
import ModifierGroupsScrollView from './components/ModifierGroupsScrollView';
import style from './Info.module.scss';

interface IInfo {
	isOpenInfo: boolean;
	data: IItemModifier;
}

const Info: React.FC<IInfo> = ({ isOpenInfo, data }) => {
	const containerClasses = classNames(style.container, { [style.visible]: isOpenInfo });
	const descriptionClasses = classNames(style.blockValue, style.description);
	const externalIdClasses = classNames(style.blockValue, style.externalId);

	const restaurants = data.restaurantsModifiers.map((el) => ({
		...el,
		id: el.restaurantId,
	}));
	const isDisabledInRestaurants = restaurants.filter((el) => el.isDisabled);
	const isRestrictedInRestaurants = restaurants.filter((el) => el.isRestricted);
	const isPreselectedInRestaurants = restaurants.filter((el) => el.isPreselected);
	const quantityRegulationRestaurants = restaurants
		.filter((el) => el.quantityMaxLimit)
		.map((el) => ({ ...el, restaurantName: `${el.restaurantName} / ${el.quantityMaxLimit}` }));

	return (
		<div className={containerClasses}>
			<div className={style.wrapper}>
				<div className={style.infoContainer}>
					<div className={style.block}>
						<Text
							className={style.blockName}
							translationNameSpace="listing"
							translationKey="nameOfModifierLabel"
							theme="neutralLight"
							withTooltip={true}
						/>
						<Text className={style.blockValue} translationKey={data.name} withTooltip={true} />
						<Text
							className={style.blockName}
							translationNameSpace="listing"
							translationKey="customerLabel"
							theme="neutralLight"
							withTooltip={true}
						/>
						<Text className={style.blockValue} translationKey={data.customer.name} withTooltip={true} />
						<Text
							className={style.blockName}
							translationNameSpace="listing"
							translationKey="articleNumberLabel"
							theme="neutralLight"
							withTooltip={true}
						/>
						<Text className={style.blockValue} translationKey={data.articleNumber} withTooltip={true} />
						<Text
							className={style.blockName}
							translationNameSpace="listing"
							translationKey="externalIdLabel"
							theme="neutralLight"
							withTooltip={true}
						/>
						<Text className={externalIdClasses} translationKey={data.externalId} withTooltip={true} />
						<Text
							className={style.blockName}
							translationNameSpace="listing"
							translationKey="descriptionLabel"
							theme="neutralLight"
							withTooltip={true}
						/>
						<Text className={descriptionClasses} translationKey={data.description} withTooltip={true} />
					</div>
					<div className={style.block}>
						<Text
							className={style.blockName}
							translationNameSpace="listing"
							translationKey="restaurantWithPriceLabel"
							theme="neutralLight"
							withTooltip={true}
						/>
						<div className={style.blockValue}>
							<PricesScrollableList restaurants={restaurants} />
						</div>
					</div>
					<div className={style.block}>
						<Text
							className={style.blockName}
							translationNameSpace="listing"
							translationKey="inStopLabel"
							theme="neutralLight"
							withTooltip={true}
						/>
						<div className={style.blockValue}>
							<RestaurantsScrollableList restaurants={isDisabledInRestaurants} />
						</div>
					</div>
					<div className={style.block}>
						<Text
							className={style.blockName}
							translationNameSpace="listing"
							translationKey="isRestrictedLabel"
							theme="neutralLight"
							withTooltip={true}
						/>
						<div className={style.blockValue}>
							<RestaurantsScrollableList restaurants={isRestrictedInRestaurants} />
						</div>
					</div>
					<div className={style.block}>
						<Text
							className={style.blockName}
							translationNameSpace="listing"
							translationKey="preselectedModifiersLabel"
							theme="neutralLight"
							withTooltip={true}
						/>
						<div className={style.blockValue}>
							<RestaurantsScrollableList restaurants={isPreselectedInRestaurants} />
						</div>
					</div>
					<div className={style.block}>
						<Text
							className={style.blockName}
							translationNameSpace="listing"
							translationKey="quantityRegulationLabel"
							theme="neutralLight"
							withTooltip={true}
						/>
						<div className={style.blockValue}>
							<RestaurantsScrollableList restaurants={quantityRegulationRestaurants} />
						</div>
					</div>
					<div className={style.block}>
						<Text
							className={style.blockName}
							translationNameSpace="listing"
							translationKey="modifierGroupLabel"
							theme="neutralLight"
							withTooltip={true}
						/>
						<div className={style.blockValue}>
							<ModifierGroupsScrollView data={data.modifierGroups} />
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default React.memo(Info);
